/**
 * Runtime configuration for the EDGE web SPA.
 *
 * - `API_BASE` is the URL prefix used when calling the EDGE Orchestrator Worker.
 *   In dev it's empty so requests go to `/api/...` and Vite's proxy forwards
 *   them to the local Worker on port 8787. In production it's set in
 *   `.env.production` to the deployed workers.dev (later: api.edge.…) URL.
 *
 * - `ADMIN_TOKEN` is the bearer token sent on every authenticated request.
 *   Phase 1 single-user; wired in Session 1b. Read from `VITE_ADMIN_TOKEN`
 *   (kept in `apps/web/.env.local`, gitignored).
 */
export const API_BASE: string = import.meta.env.VITE_API_URL ?? "";
// Bearer is DEV-ONLY now. Production auth is Cloudflare Access (same-origin
// cookie → Access JWT), so the prod bundle must carry NO token — the old build
// leaked the admin token publicly. In dev, the local Worker still accepts it.
export const ADMIN_TOKEN: string = import.meta.env.DEV
  ? (import.meta.env.VITE_ADMIN_TOKEN ?? "")
  : "";

export function apiUrl(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE}${p}`;
}
